import { render } from "./Approach.vue?vue&type=template&id=704e221e"
import script from "./Approach.vue?vue&type=script&setup=true&lang=js"
export * from "./Approach.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/public/newAccount/Approach.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "704e221e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('704e221e', __exports__)) {
    api.reload('704e221e', __exports__)
  }
  
  module.hot.accept("./Approach.vue?vue&type=template&id=704e221e", () => {
    api.rerender('704e221e', render)
  })

}


export default __exports__